/**
 * @generated SignedSource<<7e2230d69911eb042cdce57a0d6e8895>>
 * @relayHash e971708a2a993d4246b040b9f0efd62e
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 7f3b993375f3c56e02ac8cc8defc32697b23f9a982ed7e0d40f90bc8a5cf73bc

import type { ConcreteRequest, Query } from 'relay-runtime';
export type JiraSprintState = "ACTIVE" | "CLOSED" | "FUTURE" | "%future added value";
export type getSprintPropsQuery$variables = {
  cloudId: string;
};
export type getSprintPropsQuery$data = {
  readonly jira: {
    readonly jqlBuilder: {
      readonly recentlyUsedSprints: {
        readonly edges: ReadonlyArray<{
          readonly node: {
            readonly displayName: string;
            readonly jqlTerm: string;
            readonly sprint: {
              readonly boardName: string | null | undefined;
              readonly state: JiraSprintState | null | undefined;
            };
          } | null | undefined;
        } | null | undefined> | null | undefined;
      } | null | undefined;
    } | null | undefined;
  };
};
export type getSprintPropsQuery = {
  response: getSprintPropsQuery$data;
  variables: getSprintPropsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "cloudId",
    "variableName": "cloudId"
  }
],
v2 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 5
  }
],
v3 = {
  "kind": "ScalarField",
  "name": "jqlTerm"
},
v4 = {
  "kind": "ScalarField",
  "name": "displayName"
},
v5 = {
  "kind": "ScalarField",
  "name": "state"
},
v6 = {
  "kind": "ScalarField",
  "name": "boardName"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "getSprintPropsQuery",
    "selections": [
      {
        "kind": "RequiredField",
        "field": {
          "concreteType": "JiraQuery",
          "kind": "LinkedField",
          "name": "jira",
          "plural": false,
          "selections": [
            {
              "args": (v1/*: any*/),
              "concreteType": "JiraJqlBuilder",
              "kind": "LinkedField",
              "name": "jqlBuilder",
              "plural": false,
              "selections": [
                {
                  "args": (v2/*: any*/),
                  "concreteType": "JiraJqlSprintFieldValueConnection",
                  "kind": "LinkedField",
                  "name": "recentlyUsedSprints",
                  "plural": false,
                  "selections": [
                    {
                      "concreteType": "JiraJqlSprintFieldValueEdge",
                      "kind": "LinkedField",
                      "name": "edges",
                      "plural": true,
                      "selections": [
                        {
                          "concreteType": "JiraJqlSprintFieldValue",
                          "kind": "LinkedField",
                          "name": "node",
                          "plural": false,
                          "selections": [
                            (v3/*: any*/),
                            (v4/*: any*/),
                            {
                              "concreteType": "JiraSprint",
                              "kind": "LinkedField",
                              "name": "sprint",
                              "plural": false,
                              "selections": [
                                (v5/*: any*/),
                                (v6/*: any*/)
                              ]
                            }
                          ]
                        }
                      ]
                    }
                  ],
                  "storageKey": "recentlyUsedSprints(first:5)"
                }
              ]
            }
          ]
        },
        "action": "THROW",
        "path": "jira"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "getSprintPropsQuery",
    "selections": [
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v1/*: any*/),
            "concreteType": "JiraJqlBuilder",
            "kind": "LinkedField",
            "name": "jqlBuilder",
            "plural": false,
            "selections": [
              {
                "args": (v2/*: any*/),
                "concreteType": "JiraJqlSprintFieldValueConnection",
                "kind": "LinkedField",
                "name": "recentlyUsedSprints",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "JiraJqlSprintFieldValueEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "concreteType": "JiraJqlSprintFieldValue",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v3/*: any*/),
                          (v4/*: any*/),
                          {
                            "concreteType": "JiraSprint",
                            "kind": "LinkedField",
                            "name": "sprint",
                            "plural": false,
                            "selections": [
                              (v5/*: any*/),
                              (v6/*: any*/),
                              {
                                "kind": "ScalarField",
                                "name": "id"
                              }
                            ]
                          }
                        ]
                      }
                    ]
                  }
                ],
                "storageKey": "recentlyUsedSprints(first:5)"
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "7f3b993375f3c56e02ac8cc8defc32697b23f9a982ed7e0d40f90bc8a5cf73bc",
    "metadata": {},
    "name": "getSprintPropsQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "6f6cfbf4bab20faeb9306f8a03189ef2";

export default node;
